import { fromEvent } from 'rxjs/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import { updateTableData } from '../../redux/modules/reporting/interactionMonitoring';
import store from '../../redux/store.js';

const SUBSCRIPTION_TOPICS = [
  'cxengage/reporting/batch-response',
  'cxengage/session/started',
  'cxengage/interactions/messaging/silent-monitor-start',
  'cxengage/interactions/messaging/silent-monitor-start-acknowledged',
  'cxengage/interactions/messaging/silent-monitor-end',
  'cxengage/interactions/messaging/silent-monitor-end-acknowledged',
  'cxengage/interactions/messaging/silent-monitor-message-history',
  'monitorMessaging',
];

export function messageObservable() {
  return fromEvent(window, 'message')
    .filter(({ data }) => data.subscription && SUBSCRIPTION_TOPICS.includes(data.subscription.topic))
    .map(({ data }) => {
      if (data.subscription.topic === 'cxengage/reporting/batch-response') {
        // This dot-access is extremely cursed but using ?. isn't supported in this babel version, so it has to stay
        store.dispatch(
          updateTableData(data.subscription.response.interactionsInConversationList.body.results.interactions)
        );
      } else if (data.subscription.topic === 'cxengage/session/started') {
        store.dispatch({
          type: data.subscription.topic,
          response: data.subscription.response,
        });
      } else {
        store.dispatch({
          type: data.subscription.topic,
          response: data.subscription.response,
        });
      }
    });
}

let subscription;
export function messageSubscribe() {
  subscription = messageObservable().subscribe();
}
export function messageUnsubscribe() {
  subscription.unsubscribe();
}
